<!-- Contenido del segundo tab (Consumption) -->
<div class="row d-lg-block mt-3 grafic" [ngClass]="{'d-none': useMobileLayout }">
    <div class="chart-container">
        <canvas #chartCanvas id="myChart"></canvas>
    </div>
</div>

<!-- Cards para mobile -->
<div *ngIf="useMobileLayout" class="row d-lg-none mt-3">
    <div class="col-12">
        <div class="card mb-3" *ngFor="let month of rangeMonts; let i = index">
            <div class="card-body">
                <h5 class="card-title">
                    <strong>{{ month }}</strong>
                </h5>
                <p class="card-text">
                    <strong>Usage:</strong>
                    {{ monthlyConsumption[i].toLocaleString() }} MB<br />
                </p>
            </div>
        </div>
    </div>
</div>